<div class="wrap">
  <app-svg-icon
    name="close"
    class="close-btn"
    (click)="modalService.dismiss(false)"
  ></app-svg-icon>
  <div class="header">
    <app-svg-icon
      class="danger-icon"
      name="info"
      color="color-state-error"
    ></app-svg-icon>
    <div class="text">
      {{ "@components.orderTypeSwitchWarning.headerText" | translate }}
    </div>
  </div>
  <div class="items-info">
    {{
      "@components.orderTypeSwitchWarning.itemsQuantityText"
        | translate
          : {
              itemsQuantity
            }
    }}
  </div>

  <div class="hint">
    {{ "@components.orderTypeSwitchWarning.hint" | translate }}
  </div>
  <div class="action-btns">
    <app-action-button
      [label]="
        '@components.orderTypeSwitchWarning.actionBtns.accept' | translate
      "
      (click)="modalService.dismiss(true)"
    ></app-action-button>
    <app-action-button
      [isOutlined]="true"
      [label]="
        '@components.orderTypeSwitchWarning.actionBtns.cancel' | translate
      "
      (click)="modalService.dismiss(false)"
    ></app-action-button>
  </div>
</div>
